import React from 'react';

const ScheduleItem: React.FC<{
  time: string;
  title: string;
  description: string[];
}> = ({ time, title, description }) => (
  <div className="card-natural">
    <div className="flex flex-col md:flex-row md:items-start gap-4">
      <div className="md:w-1/4">
        <h3 className="text-xl font-semibold text-clay-400">{time}</h3>
      </div>
      <div className="md:w-3/4">
        <h4 className="text-lg font-semibold text-sage-500 mb-2">{title}</h4>
        {description.map((item, index) => (
          <p key={index} className="text-earth-400">{item}</p>
        ))}
      </div>
    </div>
  </div>
);

const Schedule: React.FC = () => {
  const schedule = [
    {
      time: "7:15 AM - 9:30 AM",
      title: "Arrival and Gathering",
      description: [
        "I welcome children and assist with the transition from home to daycare.",
        "Children can engage in various free play activities such as puzzles, blocks, and drawing."
      ]
    },
    {
      time: "9:30 AM - 10:00 AM",
      title: "Song & Stories Circle",
      description: [
        "I lead greeting songs and take attendance.",
        "I read stories and discuss the daily theme."
      ]
    },
    {
      time: "10:00 AM - 10:30 AM",
      title: "Circle Time",
      description: [
        "I discuss the weather, calendar, and daily schedule with the children.",
        "I lead group activities and learning exercises."
      ]
    },
    {
      time: "10:30 AM - 12:00 PM",
      title: "Snack Time and Outdoor/Project Activities",
      description: [
        "I provide a healthy snack.",
        "I supervise outdoor play or project-based activities."
      ]
    },
    {
      time: "12:00 PM - 12:45 PM",
      title: "Lunch",
      description: [
        "Parents provide lunch from home.",
        "I encourage social interaction and proper table manners."
      ]
    },
    {
      time: "12:45 PM - 2:30 PM",
      title: "Cot & Quiet Time",
      description: [
        "I provide quiet time for naps or restful activities.",
        "I maintain a calm environment with dimmed lights and soft music."
      ]
    },
    {
      time: "2:30 PM - 2:45 PM",
      title: "Choose and Do",
      description: [
        "I guide children in choosing their activities, such as crafts, sensory play, or educational games."
      ]
    },
    {
      time: "2:45 PM - 3:00 PM",
      title: "Afternoon Snack",
      description: [
        "I offer a light snack."
      ]
    },
    {
      time: "3:00 PM - 4:00 PM",
      title: "Choose and Do",
      description: [
        "I continue to guide free play or theme-based activities."
      ]
    },
    {
      time: "4:00 PM - 4:30 PM",
      title: "Departure",
      description: [
        "I welcome parents and provide updates on their child's day.",
        "I supervise quiet activities while children wait for their parents."
      ]
    }
  ];

  return (
    <div className="max-w-4xl mx-auto space-y-8">
      <section className="card-natural">
        <h1 className="text-4xl font-bold text-clay-500 mb-6">Daily Schedule</h1>
        <p className="text-earth-400">
          My daily schedule is thoughtfully structured while remaining flexible to accommodate individual needs and interests. I implement developmentally appropriate activities designed to foster growth across all domains.
        </p>
      </section>

      <div className="space-y-4">
        {schedule.map((item, index) => (
          <ScheduleItem
            key={index}
            time={item.time}
            title={item.title}
            description={item.description}
          />
        ))}
      </div>
    </div>
  );
};

export default Schedule; 